<template>
  <modal
    name="action-reports-modal"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '50%'"
    :scrollable="true"
  >
    <div
      class="pt-3 pb-2 pr-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200"
    >
      <h4 class="inline-block w-11/12 text-xl">AKSİYON RAPORU</h4>
      <button class="p-2 w-1/12" @click="$modal.hide('action-reports-modal')">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div
      class="p-4 bg-white dark:bg-gray-900 text-black dark:text-gray-200 border-gray-200 border-b border-t border-opacity-30"
    >
      <p class="border-b pb-2 px-2 mb-5 font-bold">GENEL</p>
      <div class="w-full">
        <diffInput
          :value="detail?.state"
          title="Durum"
          type="text"
          disabled="true"
        />
      </div>

      <div class="flex items-center justify-between mt-5">
        <div class="w-full">
          <diffInput
            :value="detail?.tonnage + ' TON'"
            title="Toplam Taşıma Miktarı"
            type="text"
            disabled="true"
          />
        </div>
        <div class="w-full pl-3">
          <diffInput
            :value="
              (detail?.receivedTonnage ? detail?.receivedTonnage : '0.00') +
              ' TON'
            "
            title="Toplam Taşınan Miktarı"
            type="text"
            disabled="true"
          />
        </div>
      </div>

      <p class="border-b pb-2 px-2 my-5 font-bold">SAATLİK</p>
      <div class="flex items-center justify-between">
        <div class="w-full">
          <diffInput
            :value="
              actionState?.perDayEstimatedAmount == null
                ? '-'
                : actionState?.perDayEstimatedAmount + ' TON'
            "
            title="Hedeflenen Taşıma Miktarı"
            type="text"
            disabled="true"
          />
        </div>
        <div class="w-full pl-3">
          <diffInput
            :value="actionState?.dailyShipmentAmount + ' TON'"
            title="Gerçekleşen Taşıma Miktarı"
            type="text"
            disabled="true"
          />
        </div>
      </div>

      <div class="w-full mt-5">
        <diffInput
          :value="
            actionState?.perVehicleDailyShipmentTonnage + ' TON'
          "
          title="Araç Başı Gerçekleşen Taşıma Miktarı"
          type="text"
          disabled="true"
        />
      </div>

      <p
        v-if="[6, 7].includes(detail?.stateId)"
        class="border-b pb-2 px-2 my-5 font-bold"
      >
        ÖNERİLEN
      </p>
      <p
        v-else
        class="text-lg text-left font-bold mt-5 text-red-500 border my-5 p-2 py-3 bg-gray-100 rounded-md"
      >
        {{ actionState?.explanation }}
      </p>

      <div
        v-if="[6, 7].includes(detail?.stateId)"
        class="flex items-center justify-between mt-5"
      >
        <div class="w-full">
          <diffInput
            :value="actionState?.vehicleCount + ' ARAÇ'"
            title="Mevcut Araç Sayısı"
            type="text"
            disabled="true"
          />
        </div>
        <div class="w-full pl-3">
          <diffInput
            :value="
              (detail?.stateId === 7
                ? actionState?.vehicleCount +
                  actionState?.recommendedVehicleCount
                : actionState?.vehicleCount -
                  actionState?.recommendedVehicleCount) + ' ARAÇ'
            "
            title="Önerilen Yeni Araç Sayısı"
            type="text"
            disabled="true"
          />
        </div>
      </div>

      <div class="w-full mt-4 px-2" v-if="detail?.stateId === 7">
        <!-- Öneri Nedeni Açıklaması -->
        <div
          v-if="actionState?.explanation"
          class="mb-4 p-3 bg-yellow-50 dark:bg-yellow-900 border border-yellow-300 dark:border-yellow-600 rounded-md"
        >
          <p
            class="text-sm font-semibold text-yellow-800 dark:text-yellow-200 mb-1"
          >
            📋 Öneri Nedeni:
          </p>
          <p class="text-sm text-yellow-700 dark:text-yellow-300">
            {{ actionState.explanation }}
          </p>
        </div>

        <p class="mt-2 text-base font-bold">ARAÇ LİSTESİ</p>
        <vehicleList
          v-if="actionState?.recommendedVehicleCount > 0"
          :totalCount="actionState?.recommendedVehicleCount"
          :haveType="3"
          :order="getOrderDetail"
          :recomendedList="filteredRecommendedVehicles"
          :reserveCount="0"
          :height="'225px'"
          :calculateState="true"
          :hiddenInsert="false"
          @change="(val) => (newVehicleList = val)"
        />
      </div>

      

      <div class="w-full mt-4 px-2" v-else-if="detail?.stateId === 6">
        <vehicleModal :detail="selectedVehicle" />
        <p class="mt-2 text-base font-bold">ARAÇ LİSTESİ</p>
        <table class="min-w-full divide-y divide-gray-200">
          <thead
            class="bg-white border-black border-dotted border-b-2 border-opacity-20"
          >
            <tr>
              <th
                scope="col"
                class="table-th text-left border-r border-opacity-20"
                style="min-width: 50px !important"
              >
                #
              </th>
              <th
                scope="col"
                class="table-th text-left border-r border-opacity-20 z-50"
                style="min-width: 100px !important"
              >
                Araç
              </th>
              <th
                scope="col"
                class="table-th text-left border-r border-opacity-20"
                style="min-width: 200px !important"
              >
                Sürücü
              </th>
              <th
                scope="col"
                class="table-th text-center border-r border-opacity-20"
                style="min-width: 100px !important"
              >
                Detay
              </th>
            </tr>
          </thead>
          <tbody class="divide-gray-500" style="background-color: #3a3a3a">
            <tr
              v-for="(item, index) in filteredRecommendedVehicles"
              :key="index"
            >
              <td class="table-td border-r border-opacity-20">
                <span># {{ index + 1 }} </span>
              </td>
              <td class="table-td border-r border-opacity-20">
                {{ item.plaque }}
              </td>
              <td class="table-td border-r border-opacity-20">
                {{ item.name }}
              </td>
              <td class="table-td border-r border-opacity-20 text-center">
                <button
                  @click="showVehicleDetail(item)"
                  class="px-3 py-1 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                  title="Araç detayını görüntüle"
                >
                  <i class="fas fa-info-circle mr-1"></i>
                  Detay
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-full mt-4 text-right">
        <asyncBtn
          icon="fas fa-check"
          :text="
            detail?.stateId === 5 ? 'Gerekli Aksiyonu Aldım' : 'Aksiyon Al'
          "
          loadTitle="Aksiyon Alınıyor"
          :loadState="load"
          @click="save"
          class="w-full md:w-56"
        />
      </div>
    </div>
  </modal>
</template>

<script>
// Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import vehicleList from "@/components/general/vehicleTable/vehicles.vue";
import vehicleModal from "@/components/modals/vehicle.detail.modal/index.vue";

// Networking
import axios from "axios";
import { bulkPlanning } from "@/networking/urlmanager";

export default {
  name: "action-report-modal",
  props: ["detail"],
  components: {
    diffInput,
    asyncBtn,
    vehicleList,
    vehicleModal,
  },
  data() {
    return {
      load: false,
      newVehicleList: [],
      selectedVehicle: null,
    };
  },
  methods: {
    showVehicleDetail(vehicle) {
      this.selectedVehicle = {
        ...vehicle,
        vehicle: vehicle.plaque,  // Modal vehicle field'i bekliyor
        plate: vehicle.plaque,
        capacity: vehicle.capacity || 0,
        outpointLng: Number(this.detail.fillingLongitude),
        outpointLat: Number(this.detail.fillingLatitude),
        targetPointLng: Number(this.detail.deliveryLongitude),
        targetPointLat: Number(this.detail.deliveryLatitude),
        deliveryDate: this.detail.estimatedComplateDate,
        tonnage: parseFloat(this.detail.tonnage),
        productType: this.detail.productType,
        customer: this.detail.customer,
        orderNo: this.detail.orderNo,
        // recommendation detayları zaten vehicle içinde olmalı
        recomendation: vehicle.recomendation || {},
      };
      this.$modal.show("vehicle-modal");  // ✅ Doğru modal adı
    },
    save() {
      if (this.detail?.stateId === 7 && this.newVehicleList?.length == 0) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "aksiyonu gerçekleştirmek için araç listesinin dolu olması gerekiyor!"
        );
        return;
      }

      this.swalBox(
        "warning",
        " Plan için aksiyonu almak istediğinize emin misiniz     ? ",
        "(Lütfen aldığınız aksiyonu aşağıda açıklayınız...) ",
        true,
        this.$t("general.confirmText"),
        this.$t("general.rejectText"),
        true
      ).then((acc) => {
        if (acc.isConfirmed) {
          this.load = true;
          // recommendedVehicles
          axios
            .post(
              bulkPlanning.saveAction,
              {
                rowId: this.detail.id,
                type: this.detail.stateId,
                vehicleList:
                  this.detail?.stateId === 6
                    ? JSON.stringify(
                        this.filteredRecommendedVehicles
                      )
                    : JSON.stringify(this.newVehicleList),
                vehicleCount:
                  this.actionState?.recommendedVehicleCount,
                note: acc.value.toString(),
              },
              {
                headers: {
                  Authorization: "Bareer " + this.$store.state.userData.token,
                },
              }
            )

            .then(() => {
              this.swalBox(
                "success",
                this.$t("general.successTitle"),
                "",
                false,
                this.$t("general.OkayTitle")
              );
              this.$emit("refresh", true);
              this.load = false;
              this.$modal.hide("action-reports-modal");
            })
            .catch((err) => {
              this.errorBox(err.response);
              this.load = false;
            });
        }
      });
    },
    
  },

  computed: {
    isCrisisMode() {
      // Kriz modu: Sadece rejectStatus varsa, canlı atama aktif değilse ve araç eksikse
      const assignedVehicles = this.assignedVehicleCount;
      const requiredVehicles = this.detail?.recomendedCount || 0;
      const isCompleted = this.detail?.state === 'Tamamlandı' || this.detail?.stateId === 9;
      const hasRejectStatus = this.detail?.rejectStatus > 0;
      const isLiveAssignment = this.detail?.isLiveAssignment;
      return !isCompleted && !isLiveAssignment && hasRejectStatus && requiredVehicles > 0 && assignedVehicles < requiredVehicles;
    },
    actionState() {
      return this.detail?.actionState?.[0] || {};
    },
    assignedVehicleCount() {
      // Atanmış araç sayısını hesapla (sent + reserved)
      if (!this.detail) return 0;

      const sentCount = Number(this.detail.sentVehicleCount) || 0;
      const reservedCount = Number(this.detail.reservedVehicleCount) || 0;

      return sentCount + reservedCount;
    },
    vehicleDeficit() {
      // Eksik araç sayısını hesapla
      const required = this.detail?.recomendedCount || 0;
      return Math.max(0, required - this.assignedVehicleCount);
    },
    getOrderDetail() {
      return {
        ...this.detail,
        outpointLat: Number(this.detail.fillingLatitude),
        outpointLng: Number(this.detail.fillingLongitude),
        targetPointLat: Number(this.detail.deliveryLatitude),
        targetPointLng: Number(this.detail.deliveryLongitude),
        deliveryDate: this.detail.estimatedComplateDate,
        tonnage: parseFloat(this.detail.tonnage),
        productType: this.detail.productType,
      };
    },
    filteredRecommendedVehicles() {
      // Eğer detail veya recommendedVehicles yoksa boş dizi döndür
      if (!this.actionState?.recommendedVehicles) {
        return [];
      }

      // ✅ Tüm araçları döndür (reddedilen araçlar dahil)
      return this.actionState.recommendedVehicles;
    },
  },
};
</script>
